// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__g3gS8","left":"styles_left__3-0Zq"};